import { useQuery } from '@apollo/client';
import { useMaTransactionsContext } from '../../../MaTransactionsContext';
import { MA_DEALS_PAGINATED_QUERY } from '../operations';

export const useGetDealsPaginated = (page, perPage, order, orderBy) => {
  const { filterVariables } = useMaTransactionsContext();
  const pagination = {
    page: page + 1,
    perPage,
    order,
    orderBy,
  };
  const { data, loading, error } = useQuery(MA_DEALS_PAGINATED_QUERY, {
    variables: { filters: filterVariables, pagination },
  });

  return {
    deals: data?.maDeals?.deals || [],
    totalCount: data?.maDeals?.totalCount,
    loading,
    error,
  };
};
